import { drawLine } from "./Utils.js";
const sides = 1;
export class LineDrawer {
    draw(data) {
        drawLine(data);
    }
    getSidesCount() {
        return sides;
    }
}
